// Shared vocabulary for colouring binary options by meaning. Used by the trade
// panel (components/trade/resolve-binary-options) and by every badge/button that
// goes through components/option-button/option-tone, so both always agree.

/** Words that take the yes (positive, green) side. */
export const BINARY_YES_WORDS = ['yes', 'option1', 'up', 'higher', 'above', 'over', 'long', 'rise', '漲', '涨', '升'];
/** Words that take the no (negative, red) side. */
export const BINARY_NO_WORDS = ['no', 'option2', 'down', 'lower', 'below', 'under', 'short', 'fall', '跌', '降'];

export type BinarySide = 'yes' | 'no';

/** Whole-label match, case and whitespace insensitive ("Upload" is not "up"). */
export const binarySideOf = (text: string | undefined): BinarySide | undefined => {
  if (!text) return undefined;
  const value = text.trim().replace(/\s+/g, ' ').toLowerCase();
  if (BINARY_YES_WORDS.includes(value)) return 'yes';
  if (BINARY_NO_WORDS.includes(value)) return 'no';
  return undefined;
};

/**
 * The subset option-tone has always matched as substrings too ("Up 5%", "跌破").
 * Kept for its existing labels; newer words (higher, over, long, ...) match whole
 * labels only, so "Overtime" or "Longhorns" stay neutral.
 */
export const SUBSTRING_YES_WORDS = ['yes', 'option1', 'up', 'rise', '漲', '涨', '升'];
export const SUBSTRING_NO_WORDS = ['no', 'option2', 'down', 'fall', '跌', '降'];
